import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { SelectItem, SelectItemGroup } from 'primeng/api';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ParticipantData } from 'projects/admin/src/app/orders/partials/participant-form/participant-form.component';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { OrderHelperService } from 'projects/admin/src/app/services/order-helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { TemplateModel } from 'projects/core/src/lib/models/template.model';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { forkJoin, Observable } from 'rxjs';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { PartnerModel } from 'projects/core/src/lib/models/partner.model';

const BACK_URL_ORDERS = '/planning/orders';
const BACK_URL_CLEARINGS = '/planning/clearings';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent extends BaseDetail implements OnInit {

  public order: AcModel = null;
  public partners: Array<PartnerModel> = [];
  public backRoute = [BACK_URL_ORDERS];
  protected identifier = 'order';

  public options: { [key: string]: Array<SelectItem | SelectItemGroup> } = {};
  public templates: Array<TemplateModel> = [];
  public texts: { [key: string]: string } = {};
  public user: ParticipantData = null;

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private orderhelper: OrderHelperService,
    private api: ApiService,
    private route: ActivatedRoute,
    public auth: AuthStateService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.setLoading();
    const params = this.route.snapshot.params;
    const segments = this.route.snapshot.url;
    let mode = null;
    if (params?.id !== undefined) {
      mode = DetailModes.edit;
    } else {
      mode = DetailModes.new;
    }
    if (segments.find(segment => segment.path === 'clearings') !== undefined) {
      this.backRoute = [BACK_URL_CLEARINGS];
    }
    const requests: Array<Observable<any>> = [
      this.api.getOrderformSetupData(mode === DetailModes.edit),
      this.api.getModels('partners')
    ];
    if (mode === DetailModes.edit) {
      requests.push(this.api.getModel('orders', params.id));
    }
    forkJoin(requests).subscribe({
      next: (results: any) => {
        if (results[0].data) {
          if (results[0].data?.options) {
            this.options = this.orderhelper.getMappedOptions(results[0].data?.options);
            this.texts = this.orderhelper.getMmappedTexts(results[0].data?.texts);
            this.templates = this.orderhelper.getTemplates(results[0].data?.templates);
            this.user = results[0].data?.user;
          }
        }
        if (results[1] && results[1].data?.length > 0) {
          results[1].data?.forEach((partner: any) => {
            this.partners.push(new PartnerModel().deserialize(partner));
          });
        }
        if (results[2] && results[2].data) {
          this.order = new AcModel().deserialize(results[2].data);
          this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.order.id), 10);
        }
        this.setInitialized(mode);
      },
      error: (error: any) => {
        this.setFailed(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  onTabChange(event: any): void {
    if (this.order !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.order.id, event.index);
    }
    this.ui.setFocus();
  }

  setClearingUrl(clearing: boolean): void {
    this.backRoute = [(clearing === true && this.auth.hasRight('admin.planning-orders.list-clearing')) ? BACK_URL_CLEARINGS : BACK_URL_ORDERS];
  }

}
